module.exports = __webpack_public_path__ + "static/media/shelter_beach_1.b3217613.svg";